// extracted by mini-css-extract-plugin
module.exports = {"CommentsSection":"CommentsSection_CommentsSection__1oe9e","RepliesInput":"CommentsSection_RepliesInput__33BiW"};